<template lang="pug">
  div
    WorkCardRepaired(:data="repaired" v-if="repaired.length > 0")
    h4.mensaje(v-else) No tienes trabajos reparados por ahora.
</template>
<script>
import { mapGetters } from 'vuex'
import WorkCardRepaired from './WorkCardRepaired.vue'
export default {
  components: {
    WorkCardRepaired
  },
  computed: {
    ...mapGetters('ot', ['repaired'])
  }
}
</script>
<style lang="scss" scoped>
.mensaje {
  text-align: center;
  margin-top: 20px;
  color: #A3A2A1;
}
</style>
